import { render, staticRenderFns } from "./amsRelation.vue?vue&type=template&id=7a48807a"
import script from "./amsRelation.vue?vue&type=script&lang=js"
export * from "./amsRelation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports